import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 14a6 6 0 1 0 0-12 6 6 0 0 0 0 12m4.5-6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.5 15.25a4.34 4.34 0 0 0-2.992 1.183 4 4 0 0 0-1.258 2.9V21a.75.75 0 0 0 1.5 0v-1.667c0-.673.28-1.326.792-1.814A2.84 2.84 0 0 1 8.5 16.75h7c.74 0 1.444.28 1.958.77.512.487.792 1.14.792 1.813V21a.75.75 0 0 0 1.5 0v-1.667a4 4 0 0 0-1.258-2.9A4.34 4.34 0 0 0 15.5 15.25z"
    }, null, -1)
  ])))
}
export default { render: render }